import {FIELDS_PATTERN} from 'src/modules/event-create/constants';

const MIN_LENGTH_DESCRIPTION = 3;
export const MAX_LENGTH_DESCRIPTION = 255;

const ERROR_MESSAGES = {
    EVENT_DESCRIPTION_MIN_LENGTH: 'Please enter correct "Event Description". ' +
        '"Event Description" length must be more than 2 characters',
    EVENT_DESCRIPTION_WRONG_CHARACTERS: 'Please enter correct "Event Description". ' +
        'Use latin alphabet and symbols: . , ( – " \' ) / + - : &',
};

export const eventDescriptionValidation = (eventDescription: string): string[] => {
    const errorMassages = [];
    const matches = eventDescription.match(FIELDS_PATTERN.description);

    if (eventDescription.length < MIN_LENGTH_DESCRIPTION) {
        errorMassages.push(ERROR_MESSAGES.EVENT_DESCRIPTION_MIN_LENGTH);
    }

    if (matches) {
        errorMassages.push(ERROR_MESSAGES.EVENT_DESCRIPTION_WRONG_CHARACTERS);
    }
    return errorMassages;
};
